
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DetailsListing",
      function () {
        return require("private-next-pages/DetailsListing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DetailsListing"])
      });
    }
  